import React from "react"
import { Accordion, Box } from "@chakra-ui/react"

import AccordionItem from "@components/AccordionItem"
import Content from "@components/Content"
import ProductDescription from "./ProductDescription"
import ProductKeyBenefits from "./ProductKeyBenefits"

export interface ProductDetailsProps {
  product: any
  keyBenefits: any
  productDetails: any
}

const ProductDetails = ({ product, keyBenefits, productDetails, infoAndCareMetafield }: ProductDetailsProps) => (
  // first two items are open by default
  <Accordion allowMultiple defaultIndex={[0, 1]} marginTop={2} borderBottomWidth={0}>
    {product?.handle?.includes("gift-card") ? null : (
      <AccordionItem title="Key Benefits">
        <ProductKeyBenefits product={product} benefits={keyBenefits} />
      </AccordionItem>
    )}
    <AccordionItem title="Details">
      <ProductDescription product={product} />
    </AccordionItem>
    {product?.handle?.includes("gift-card") ? null : (
      <AccordionItem title="Info & Care">
        <Box
          sx={{
            "br:nth-of-type(2n)": {
              display: "none",
            },
          }}
          dangerouslySetInnerHTML={{ __html: infoAndCareMetafield }}
        />
      </AccordionItem>
    )}
    <AccordionItem title="Delivery & Returns">
      <Content rawContent={productDetails.deliveryAndReturns} />
    </AccordionItem>
    <AccordionItem title="Gift Wrapping">
      <Content rawContent={productDetails.giftWrapping} />
    </AccordionItem>
  </Accordion>
)

export default React.memo(ProductDetails)
